import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { Redirect } from "react-router";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil, StringUtil } from "@eres/core";
import {
	convertTabuServiceToPropertyService,
	downloadCertificate,
	downloadSaleContract,
	downloadSitePlan,
	getUnitNumber,
	getVillaName,
	isMultiOwner,
	TabuPropertyType
} from "@my-dld/utils/PropertyUtils";
import { ImperialSystem, MetricSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import { dispatch, navigate } from "@my-dld/utils/StoreUtils";
import Actions from "@my-dld/actions";
import Switch from "@my-dld/components/Switch";
import { hideLoading, showErrorMessage, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { BCSReClassification } from "@my-dld/utils/TabuServices";
import { tabuServiceValidate } from "../TabuRequest/BaseTabuRequestForm";
import PageContent from "@my-dld/components/PageContent";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { switchEjariUserMode } from "@eres/ejari-core/contexts/EjariContext";
import { DetailsKVProps } from "@eres/ejari-web/types";
import { ServiceCard } from "@my-dld/components/ServiceContainer";
import ServiceDescriptions from "@my-dld/assets/strings/property_serv_desc";
import { validateProperty } from "../../enocapi/api";
import RejectionActions, { createNewENocRequest } from "@my-dld/components/ENocMollak/RejectionModel";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { getAppServices } from "@10x/coreapp";
import _ from "lodash";
import { Api as BcsApi, DTO as BcsDTO } from "@10x/bcs";
import BcsRating from "@my-dld/components/BCSRating";
import { ITabuSmartService, TabuProcedures, TabuRequestUtils } from "@10x/tabu-mobile-api";
import { ProcedureIDs } from "@10x/tabu-mobile-api/dist/requests/entity";
import { Details } from "@my-dld/components/PropertyDetails/Details";
import { DetailsTabs } from "@my-dld/components/PropertyDetails/DetailsTabs";
import { featureGateCheck, UaePassUserFilter } from "@my-dld/utils/Utils";
import { canDoAnnex } from "@my-dld/utils/TabuUtils";
import { TabuRequestContext } from "@my-dld/contexts/TabuRequestContext";
import { isMultiPropertyProcedure } from "@my-dld/utils/ProcedureUtils";
import { PropertyCoOccupants } from "@eres/ejari-web/component/CoOccupant/CoOccupants";
import { Gated } from "@10x/feature-gate";
import JOPServices, { JOPUserType } from "../JOPServices";
import { JOPApi, JopGateAPI } from "../JOPServices/Api";
import { getJOPServices } from "../JOPServices/Api/api";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { OwnerCommitteeApi } from "../../ownercommitteeapi";
import { IJOPServices } from "../JOPServices/JOPService";

interface Props extends RoutedViewProps<{ propertyTypeId: string; propertyId: string; hideServices?: string }, { property: AssetCard }> {

}


interface State {
	property: AssetCard;
	unit: UnitSystem;
	showEnocMActions: boolean;
	enocException?: any;
	bcsRating?: BcsDTO.BCSRating;
	hideServices: boolean;
	showJOP?: boolean;
	jopServices? : IJOPServices;
}

class PropertyDetails extends Component<Props, State> {
	static contextType = TabuRequestContext;
	context!: React.ContextType<typeof TabuRequestContext>;

	constructor( props: Props ) {
		super( props );
		let property = props.location.state ? props.location.state.property : undefined;
		const store = getAppServices().storeService.getStore();
		if ( !property ) {
			property = getSelectedProperty( props.match.params );
		}
		this.state = {
			property: property!,
			unit: store.getState().User.unit,
			showEnocMActions: false,
			hideServices: props.match.params.hideServices === "true",
			showJOP: false,
		};
	}

	componentWillUnmount() {
		JQModal( "rejection_request" ).hide();
	}

	componentDidMount(): void {
		if ( this.state.property ) {
			trackEventWithData( "Property", "View", {
				type: this.state.property.propertyTypeId,
				id: this.state.property.propertyId
			} );
			this.getBCSRating();
			JopGateAPI.getJOPServices( TabuProfile.getParticipantNumber()! , this.state.property.propertyId )
			.then( r => {
				if ( r && r.validationErrorsList && r.validationErrorsList.length > 0 ) {
					showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
				} else if ( r && r.response && r.response ) {
					 this.setState( { showJOP: r.response.canInquiry || r.response.canLegal || r.response.canSuggestion || r.response.canComplaint  ,
						 jopServices: {
							 canInquiry:  r.response.canInquiry,
							 canLegal: r.response.canLegal,
							 canComplaint: r.response.canComplaint,
							 canSuggestion: r.response.canSuggestion,
						 }} );
				}
			} )
			.catch( reason => {
				showErrorMessage( reason );
			} );
		}
	}

	handleTabuService = ( id: string ) => {
		const tsv = TabuRequestUtils.getTabuServiceByStringId( id );
		if ( tsv ) {
			const { property } = this.state;
			const Id = tsv.Id as ProcedureIDs;
			switch ( Id ) {
				case ProcedureIDs.ELECTRONIC_TITLE_DEED:
					downloadCertificate( property );
					return true;
				default:
					this.openService( Id, id );
					return true;
			}
		}
		return false;
	};

	handleServiceAction = ( id: string ) => {
		if ( !this.handleTabuService( id ) ) {
			const { property } = this.state;
			switch ( id ) {
				case "rt_registration":
					trackEventWithData( "Property", "RTRegistration", {
						tabuPropertyId: property.tabuPropertyId,
					} );
					navigate( `/mydld/rt/procedure/${ property.tabuPropertyId }`, undefined, {
						property: property
					} );
					break;
				case "ejari":
					switchEjariUserMode( "owner" );
					navigate( `${ property.tabuPropertyId }/ejarisvc` );
					break;
				case "owner_committee":
					trackEventWithData( "Property", "OwnerCommittee", {
						tabuPropertyId: property.tabuPropertyId,
					} );
					navigate( `/mydld/owner_committee`, undefined, {
						property: property
					} );
					break;
				case "raise_a_complaint":
					trackEventWithData( "Property", "RegisterRVSComplaint", {
						tabuPropertyId: property.tabuPropertyId,
					} );
					navigate( `/mydld/rvs/complaint/register`, undefined, {
						property: property
					} );
					break;
				case "mollak_service_charges":
					navigate( `/mydld/mollak_service_charges/${ property.propertyTypeId }/${ property.propertyId }`, undefined, {
						property: property
					} );
					break;
				case "external_valuation":
					trackEventWithData( "Property", "ExternalValuation", {
						tabuPropertyId: property.tabuPropertyId,
					} );
					navigate( `/mydld/external_valuation`, undefined, {
						property: property
					} );
					break;
				case "mortgage_quotation":
					navigate( `/mydld/mortgage_quotation/${ property.propertyTypeId }/${ property.propertyId }`, undefined, {
						property: property
					} );
					break;
				case "sale_contract":
					downloadSaleContract( property );
					break;
				case "site_plan_download":
					downloadSitePlan( property );
					break;
				case "rdc_cases":
					trackEventWithData( "Property", "RDCCases", {
						tabuPropertyId: property.tabuPropertyId,
					} );
					navigate( `/mydld/rdc_cases`, undefined, {
						property: property
					} );
					break;
				case "enoc_mollak":
					trackEventWithData( "Property", "eNocMollak", {
						tabuPropertyId: this.state.property.propertyId
					} );
					this.startENocMollak();
					break;
				case "sell_prop":
					trackEventWithData( "Property", "PrivateSell", {
						tabuPropertyId: this.state.property.propertyId
					} );
					navigate( `/mydld/privateSell/`, undefined, {
						property: property,
					} );
					break;
				case "ppty_cooccupant":
					trackEventWithData( "Property", "ManageCoOccupant", {
						tabuPropertyId: this.state.property.propertyId
					} );
					navigate( `/mydld/property/${ property.propertyTypeId }/${ property.propertyId }/${ property.isFreeHold }/cooccupants/`, undefined, {
						property: property,
					} );
					break;
				case "jop_services":
					navigate( `/mydld/jop`, undefined, { property: property , userType :  JOPUserType.OWNER, jopServices: this.state.jopServices } );
					break;
			}
		}
	};

	JOPServices = {
		id: "jop_services",
		label: Strings.jop_services,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: true,
	};
	RTService = {
		id: "rt_registration",
		label: Strings.rt_register_transaction_at_rt_office,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	EjariService = {
		id: "ejari",
		label: Strings.ejari_services,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	CommitteeService = {
		id: "owner_committee",
		label: Strings.owner_committee_reg,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	RegisterComplaintService = {
		id: "raise_a_complaint",
		label: Strings.register_a_complaint,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	MollakServiceCharges = {
		id: "mollak_service_charges",
		label: Strings.mollak_service_charges,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	ExternalValuation = {
		id: "external_valuation",
		label: Strings.external_valuation,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	MortgageQuotationService = {
		id: "mortgage_quotation",
		label: Strings.mortgage_quotation,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	RDCCaseList = {
		id: "rdc_cases",
		label: Strings.rdc_cases,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	EnocMollakService = {
		id: "enoc_mollak",
		label: Strings.enoc_request,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
	};
	SellProperty = {
		id: "sell_prop",
		label: Strings.sell_property,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
		requireUaePassUser: true,
	};

	PropertyCoOccupant: ServiceCard = {
		id: "ppty_cooccupant",
		label: Strings.manage_co_occupants,
		action: this.handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
		requiredFeature: "propertyCoOccupants",
	};

	openService = ( serviceID: number, path: string ) => {
		showLoading();
		const { property } = this.state;
		const isMultiProperty = isMultiPropertyProcedure( serviceID );
		if ( !isMultiProperty ) {
			trackEventWithData( "Property", "TryService", {
				service: serviceID,
				type: this.state.property.propertyTypeId,
				id: this.state.property.propertyId
			} );
		}
		tabuServiceValidate( serviceID, property.tabuPropertyId, property.propertyTypeId, property, isMultiProperty ).then( canProceed => {
			hideLoading();
			if ( canProceed ) {
				if ( !isMultiProperty ) {
					trackEventWithData( "Property", "TryServiceSucess", {
						service: serviceID,
						type: this.state.property.propertyTypeId,
						id: this.state.property.propertyId
					} );
					this.context.reset();
					setTimeout( () => {
						this.context.addProperty( property );
						navigate( `/mydld/taburequest/${ path }/${ property.propertyTypeId }/${ property.propertyId }` );
					} );
				} else {
					this.context.reset();
					setTimeout( () => {
						this.context.addProperty( property );
						this.context.addProperties( [] );
						navigate( `/mydld/taburequest/${ serviceID }/properties` );
					} );
				}
			} else {
				trackEventWithData( "Property", "TryServiceFail", {
					service: serviceID,
					reason: "duplicate",
					type: this.state.property.propertyTypeId,
					id: this.state.property.propertyId
				} );
				showErrorMessage( Strings.duplicate_tabu_error_msg );
			}
		} ).catch( ( reason ) => {
			hideLoading();
			showErrorMessage( reason );
			trackEventWithData( "Property", "TryServiceFail", {
				service: serviceID,
				reason: reason.toString(),
				type: this.state.property.propertyTypeId,
				id: this.state.property.propertyId
			} );
		} );
	};

	CT = ( tabuSvc: ITabuSmartService, extra?: Partial<ServiceCard> ) => {
		return convertTabuServiceToPropertyService( tabuSvc, this.handleServiceAction, extra );
	};

	DownloadService = this.CT( TabuProcedures.ET, { allowUnverifiedEmailUsers: true } );
	PropertyDetailCertService = this.CT( TabuProcedures.PropertyDetailCertService );
	SitePlanService = this.CT( TabuProcedures.SitePlan );
	LossCertService = this.CT( TabuProcedures.LC );
	ValuationService = this.CT( TabuProcedures.PV );
	InternalValuationService = this.CT( TabuProcedures.IPV );
	BCSReClassification = this.CT( TabuProcedures.BCSReClassification );
	OwnerShipChange = this.CT( TabuProcedures.OwnershipChange );
	PropertyCutOff = this.CT( TabuProcedures.PropertyCutOff );
	DelayedPropertyCutOff = this.CT( TabuProcedures.DelayedPropertyCutOff );
	PropertyAnnex = this.CT( TabuProcedures.PropertyAnnex );
	DelayedPropertyAnnex = this.CT( TabuProcedures.DelayedPropertyAnnex );

	render() {
		const { property, enocException, showEnocMActions, hideServices } = this.state;
		let isMortgage = false;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		if ( property.propertyStatus ) {
			const mv = LocaleUtil.getLocalValue( property.propertyStatus, "en" );
			isMortgage = ( mv === "Mortgaged_Totally" );
		}
		let services: ServiceCard[] = [];
		services.push( this.PropertyDetailCertService );
		services.push( this.BCSReClassification );
		if ( property?.blockTransaction !== 1 ) {
			services.push( this.DownloadService );
			services.push( DownloadSaleContractService( this.handleServiceAction ) );
			services.push( DownloadSitePlanService( this.handleServiceAction ) );
			if ( !property.isOffplan ) {
				services.push( this.SitePlanService );
			}
			/*if ( !isMortgage ) {
				services.push(this.LossCertService);
			}*/
			if ( window.AppInfo && window.AppInfo.config && window.AppInfo.config.enabePVC ) {
				services.push( this.ValuationService );
			}
			if ( window.AppInfo && window.AppInfo.config && window.AppInfo.config.disableInternalPropertyVal !== true ) {
				services.push( this.InternalValuationService );
			}
			services.push( this.OwnerShipChange );
			services.push( this.PropertyCutOff );
			services.push( this.DelayedPropertyCutOff );
			if ( canDoAnnex( property ) ) {
				services.push( this.PropertyAnnex );
				services.push( this.DelayedPropertyAnnex );
			}
		}
		if ( window.AppInfo && window.AppInfo.config && window.AppInfo.config.disableRTRegistration !== true ) {
			services.push( this.RTService );
		}
		if ( ( property?.propertyTypeId === TabuPropertyType.VILLA || property?.propertyTypeId === TabuPropertyType.UNIT ) ) {
			services.push( this.EjariService );
		}
		services.push( this.CommitteeService );
		services.push( this.RegisterComplaintService );
		if ( property.propertyTypeId !== TabuPropertyType.LAND && property.isFreeHold ) {
			services.push( this.MollakServiceCharges );
			const showJop = featureGateCheck( "jopServices" );
			// SOHRAB TODO
			if ( showJop && this.state.showJOP) {
				services.push( this.JOPServices );
			}
		}
		services.push( this.ExternalValuation );
		services.push( this.MortgageQuotationService );
		services.push( this.RDCCaseList );
		if ( window.AppInfo && window.AppInfo.config && window.AppInfo.config.disableEnocMollak !== true ) {
			services.push( this.EnocMollakService );
		}
		const sell = this.canSell( property );
		if ( sell ) {
			services.push( this.SellProperty );
		}
		services.push( this.PropertyCoOccupant );
		let pps = getAppServices().propertyService.getServices( property ).map( ps => {
			return {
				...ps,
				action: () => {
					ps.action( property, ps );
				}
			};
		} );
		services.push( ...pps );
		services = services.filter( UaePassUserFilter );
		services = filterProxyPropertyServices( services, property );
		services = _.sortBy( services, service => LocaleUtil.getLocalValue( service.label ).toLocaleLowerCase().trim() );
		let { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ lbl } : ${ val }` } //${ Strings.property_details } -
			titleExtra={ <Switch
				id={ "result-unit" }
				onLabel={ Strings.sq_mt }
				offLabel={ Strings.sq_ft }
				value={ this.state.unit.Id === MetricSystem.Id }
				onChange={ ( isSqm ) => {
					const update = { unit: ImperialSystem };
					if ( isSqm ) update.unit = MetricSystem;
					this.setState( update, () => {
						dispatch( Actions.UNIT_CHANGED, this.state.unit );
					} );
				} }
			/> }
			subTitleExtra={
				<BcsRating rating={ this.state.bcsRating } propertyName={ val } onReValuate={ this.onBCSReEvaluate }/>
			}
			hideQLinks={ hideServices }>
			<PageTitle title={ Strings.property_details } paths={ [ DashboardBCItem ] }/>
			{/*<Details data={ property } unit={ this.state.unit } onBCSReValuate={ this.onBCSReEvaluate }/>*/}
			<Gated featureId={ "propertyCoOccupants" }>
				<PropertyCoOccupants
					propertyId={ property.propertyId }
					propertyTypeId={ property.propertyTypeId }
					isFreeHold={ property.isFreeHold }
				/>
			</Gated>
			<DetailsTabs data={ property } services={ services } hideServices={ hideServices } unit={ this.state.unit } onBCSReValuate={ this.onBCSReEvaluate }/>
			{
				showEnocMActions && enocException &&
				<RejectionActions
					tabuProperty={ property } exception={ enocException } onDismiss={ () => {
					this.setState( { showEnocMActions: false } );
					JQModal( "rejection_request" ).hide();
				} }/>
			}
		</PageContent>;
	}

	canSell( data: AssetCard ) {
		if ( isMultiOwner( data ) ) return false;
		if ( data.isFreeHold ) return true;
		if ( data.propertyTypeId === TabuPropertyType.LAND && data.isFreeHold === false ) return true;
		return false;
	}

	onBCSReEvaluate = () => {
		this.openService( BCSReClassification.ID, "bcs_reclassification" );
	};

	private getBCSRating() {
		const property = this.state.property;
		const pType = property.propertyTypeId;
		if ( pType === TabuPropertyType.VILLA || pType === TabuPropertyType.BUILDING ) {
			let requestData: BcsDTO.PropertyRatingRequest = {
				requestType: BcsDTO.RatingType.Tabu,
				propertyId: property.propertyId,
				propertyTypeId: property.propertyTypeId,
				propertySubTypeId: property.propertySubTypeId,
				isFreeHold: property.isFreeHold,
				dmNumber: property.municipalityNo,
			};
			BcsApi.getBCSRating( requestData ).then( result => {
				this.setState( { bcsRating: result } );
			} ).catch( reason => {
			} );
		}
	}

	private startENocMollak() {
		showLoading();
		const { property } = this.state;
		validateProperty( property.tabuPropertyId ).then( response => {
			if ( response.responseCode === "Success" ) {
				trackEventWithData( "eNocMollak", "ValidationSuccess",
					{ tabuPropertyId: property.tabuPropertyId.toString() } );
				createNewENocRequest( property );
			}
		} ).catch( excep => {
			hideLoading();
			if ( excep.errorNumbers && Array.isArray( excep.errorNumbers ) && excep.errorNumbers.length > 0 ) {
				this.setState( { showEnocMActions: true, enocException: excep } );
			} else {
				trackEventWithData( "eNocMollak", "ValidationFail",
					{ tabuPropertyId: property.tabuPropertyId.toString(), reason: excep.message } );
				showMessage( excep.message );
			}
		} );
	}
}

export default PropertyDetails;

export function extractPropInfo( property: AssetCard ) {
	let val = "";
	let lbl = "";
	let icon = "land";
	switch ( property.propertyTypeId ) {
		case TabuPropertyType.LAND:
			val = property.municipalityNo;
			if ( val.startsWith( "-" ) )
				val = val.slice( 1 );
			else if ( val.endsWith( "-" ) )
				val = val.slice( 0, -1 );
			lbl = Strings.land_num_label;
			break;
		case TabuPropertyType.VILLA:
			val = getVillaName( property );
			lbl = Strings.villa_name;
			icon = "villa";
			if ( ( property as any ).propertySubTypeId === 2 ) {
				lbl = Strings.building_name;
				icon = "building";
			}
			break;
		case TabuPropertyType.BUILDING:
			val = getVillaName( property );
			lbl = Strings.building_name;
			icon = "building";
			break;
		case TabuPropertyType.UNIT:
			val = getUnitNumber( property );
			lbl = Strings.Unit_Number_Label;
			icon = "unit";
			break;
	}
	return { val, lbl, icon };
}

export function DetailsKV( props: DetailsKVProps ) {
	let value = "-";
	if ( props.value ) {
		value = LocaleUtil.getLocalValue( props.value );
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			value = "-";
		}
	}
	const v = props.valueRenderer ? props.valueRenderer() : value;
	return <div>
		<span>{ props.label }</span>
		<span><span className={ props.valueClassName }>{ v }</span></span>
	</div>;
}

function DownloadSaleContractService( handler: ( id: string ) => void ) {
	const DownloadService = {
		id: "sale_contract",
		label: Strings.download_sale_contract,
		action: handler,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: true,
	};
	return DownloadService;
}

function DownloadSitePlanService( handler: ( id: string ) => void ) {
	const DownloadService = {
		id: "site_plan_download",
		label: Strings.site_plan_download,
		action: handler,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: true,
	};
	return DownloadService;
}

export function getSelectedProperty( params: { propertyTypeId: string; propertyId: string } ) {
	if ( params ) {
		const store = getAppServices().storeService.getStore();
		const assetCards = store.getState().UserData.properties;
		const proxyAssets = store.getState().UserData.proxyProperties;
		let type = Number( params.propertyTypeId );
		let id = Number( params.propertyId );
		if ( assetCards ) {
			let find = assetCards.find( ( p: AssetCard ) => {
				return p.propertyId === id && p.propertyTypeId === type;
			} );
			if ( find )
				return find;
			if ( proxyAssets ) {
				for ( let proxyAsset of proxyAssets ) {
					const p = proxyAsset.properties?.find( ( p: AssetCard ) => {
						return p.propertyId === id && p.propertyTypeId === type;
					} );
					if ( p != null ) return p;
				}
			}
		}
	}
	return undefined;
}

const agentAllowedServiceIds: string[] = [
	"electronic_title_deed",
	"prop_valuation",
	"site_plan",
	"ptwimc",
	"ownership_change",
	"property_cut_off",
	"delayed_property_cut_off",
	"property_annex",
	"delayed_property_annex",
	"iprop_valuation"
];

export function filterProxyPropertyServices( services: ServiceCard[], property: AssetCard ): ServiceCard[] {
	if ( property.isAgent ) {
		let sx = services.filter( s => {
			return agentAllowedServiceIds.find( x => x + "" === s.id + "" ) != null;
		} );
		return [ ...sx ];
	} else {
		return [ ...services ];
	}
}
